var _circle, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInfinityinline = function SvgInfinityinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    fill: "url(#infinity_inline_svg__a)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.25 37c-4.517 0-8.1-2.697-11.25-5.541C24.85 34.303 21.267 37 16.75 37 11.925 37 8 32.963 8 28s3.925-9 8.75-9c4.517 0 8.1 2.697 11.25 5.541C31.15 21.697 34.733 19 39.25 19c4.825 0 8.75 4.037 8.75 9s-3.925 9-8.75 9Zm-7.497-9c2.432 2.155 4.84 3.857 7.497 3.857 2.068 0 3.75-1.73 3.75-3.857 0-2.127-1.682-3.857-3.75-3.857-2.657 0-5.065 1.702-7.497 3.857ZM16.75 24.143c-2.068 0-3.75 1.73-3.75 3.857 0 2.127 1.682 3.857 3.75 3.857 2.657 0 5.065-1.702 7.497-3.857-2.432-2.155-4.84-3.857-7.497-3.857Z",
    fill: "#181A1B"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "infinity_inline_svg__a",
    x1: 56,
    y1: 0,
    x2: 0,
    y2: 56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.179,
    stopColor: "#FFE600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.844,
    stopColor: "#FD6A00"
  })))));
};
export default SvgInfinityinline;